import { ProjectJob } from "../Project";
import { createDeliveryText } from "../editors/MaterialTab";
import { Launch } from "@mui/icons-material";
import { useCustomDrag } from "./CustomDragContext";

export default function JobInner({ data, onClick, style }: { data: ProjectJob; onClick: () => void; style: any }) {
  const { element, isDragging } = useCustomDrag({
    onClick,
    date: data.date,
    item: { id: data.uuid, type: "job", phase: data.phaseUuid },
  });

  const status = data.bookingState
    ? "darkgreen"
    : data.status === "PLANNING"
      ? null
      : data.status === "RAW"
        ? "yellow"
        : data.status === "READY"
          ? "orange"
          : "green";

  const content = data.materialOrders.flatMap((order, index) => {
    if (!!order.deleted) return [];
    const materialPart =
      !!order.article && !order.article.bauhof
        ? order.amount.toString().replace(/\./g, ",") +
          (!order.roundsUnit ? order.article.unit : order.amount > 1 ? "Touren" : "Tour") +
          "\u00A0" +
          order.article.name +
          " von " +
          (order.article.plantName || "?") +
          " (" +
          order.article.number +
          ")"
        : "";
    let transportPart = createDeliveryText(order.transportInformation, order.takt, order.duration, false);
    if (transportPart === "-") transportPart = "";
    if (materialPart.length + transportPart.length === 0) return [];
    return [
      <div className="hw_matorder" key={index}>
        {materialPart.length ? (
          <div className="hw_matorder_mat">
            <div className="hw_clip">{materialPart}</div>
          </div>
        ) : null}
        {transportPart.length ? (
          <div className="hw_matorder_trans">
            <div className="hw_clip">{transportPart}</div>
          </div>
        ) : null}
      </div>,
    ];
  });

  if (data.comment.length > 0) {
    content.push(
      <div className="hw_comment" key={"comment"}>
        <div className="hw_clip">{data.comment}</div>
      </div>,
    );
  }

  return (
    <div className={"hw_job_main" + (isDragging ? " dragging" : "")} style={style} {...element}>
      {!!status ? <div className={"hw_color color " + status} /> : null}
      {content.length > 0 ? (
        content
      ) : (
        <div className="hw_none">
          <Launch fontSize="small" />
        </div>
      )}
    </div>
  );
}
